import styled, { css, gapSize, rem, screenMobilePlusAndSmaller, spacingBase } from 'theme';
import borderRadius from 'theme/global/border-radius';
import boxShadow from 'theme/global/box-shadow';

interface StyledInputProps {
  error: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${() => gapSize(2)};

  label {
    display: flex;
    flex: 0 0 25%;
  }

  div {
    display: flex;
    flex-grow: 1;
  }

  ${screenMobilePlusAndSmaller(css`
    flex-direction: column;

    label {
      display: flex;
      flex: 0;
    }
  `)}
`;

export const Input = styled.input<StyledInputProps>`
  box-shadow: ${boxShadow.inset()};
  border-radius: ${borderRadius.input};
  position: relative;
  padding: ${rem(10)} ${rem(20)} ${rem(10)};
  width: 100%;
  height: ${rem(50)};
  border: var(--sys-border-width-xs) solid;
  border-color: var(--ref-color-gray-60);
  ${(p) => !!p.error && `border-bottom: ${rem(2)} solid var(--sys-color-error);`}

  &:disabled {
    box-shadow: ${() => boxShadow.inset('var(--ref-color-gray-40)')};
  }
`;

export const Label = styled('label')`
  align-self: center;
  position: relative;
  width: 100%;

  span {
    margin-left: ${() => gapSize(0.5)};
  }
`;

export const InputWrapper = styled.div<{ hideErrorLabel?: boolean }>`
  position: relative;
  margin-bottom: ${() => spacingBase};

  & + .error-message {
    margin-top: -${() => spacingBase};
    margin-bottom: ${() => spacingBase};
  }

  ${(p) =>
    p.hideErrorLabel &&
    css`
      & + .error-message {
        display: none;
      }
    `}
`;
